import React from "react";
export var Status;
(function (Status) {
    Status["idle"] = "idle";
    Status["rendering"] = "rendering";
    Status["visible"] = "visible";
    Status["hiding"] = "hiding";
})(Status || (Status = {}));
